import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

/* Router Modules */
Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/frame/order/salesOrder',
    name: 'FrameSalesOrder',
    hidden: true,
    component: () => import('@/views/crm/order/salesOrder/index.vue')
  },
  {
    path: '/frame/deliver/deliveryNote',
    name: 'FrameDeliveryNote',
    hidden: true,
    component: () => import('@/views/crm/deliver/deliveryNote/index.vue')
  },
  {
    path: '/auto-auth',
    hidden: true,
    component: () => import('@/views/login/auto-auth'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/system/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/auth-oa-redirect',
    component: () => import('@/views/login/auth-oa-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/tenderLogin',
    component: (resolve) => require(['@/views/crm/tender/mobile/login'], resolve),
    name: 'tenderLogin',
    hidden: true,
    meta: { title: '投标客户登录', icon: 'dashboard', noCache: true }
  },
  {
    path: '/tenderIndex',
    component: (resolve) => require(['@/views/crm/tender/mobile/index'], resolve),
    name: 'tenderIndex',
    hidden: true,
    meta: { title: '投标首页', icon: 'dashboard', noCache: true }
  },
  {
    path: '/tenderReceipt',
    component: (resolve) => require(['@/views/crm/tender/mobile/receipt'], resolve),
    name: 'tenderReceipt',
    hidden: true,
    meta: { title: '投标首页', icon: 'dashboard', noCache: true }
  },

  {
    path: '/tenderDetails',
    component: (resolve) => require(['@/views/crm/tender/mobile/details'], resolve),
    name: 'tenderDetails',
    hidden: true,
    meta: { title: '投标详情', icon: 'dashboard', noCache: true }
  },

  {
    path: '/myPendingIndexMobile',
    component: (resolve) => require(['@/views/flow/myPendingIndex'], resolve),
    name: 'myPendingIndexMobile',
    hidden: true,
    meta: { title: '我的待办', icon: 'dashboard', noCache: true }
  },
  {
    path: '/mobileIndex',
    component: (resolve) => require(['@/views/crm/mobile/index'], resolve),
    name: 'mobileIndex',
    hidden: true,
    meta: { title: "CRM移动端", icon: 'dashboard', noCache: true }
  },
  {
    path: '/mobileTenderIndex',
    component: (resolve) => require(['@/views/crm/mobile/tender/index'], resolve),
    name: 'mobileTenderIndex',
    hidden: true,
    meta: { title: '投标管理', icon: 'dashboard', noCache: true }
  },
  {
    path: '/examineCustomerApplication',
    component: (resolve) => require(['@/views/crm/mobile/examine/details/customerApplication'], resolve),
    name: 'examineCustomerApplication',
    hidden: true,
    meta: { title: '客户审批', icon: 'dashboard', noCache: true }
  },
  {
    path: '/examineCustomerAlter',
    component: (resolve) => require(['@/views/crm/mobile/examine/details/customerAlter'], resolve),
    name: 'examineCustomerAlter',
    hidden: true,
    meta: { title: '客户变更审批', icon: 'dashboard', noCache: true }
  },
  {
    path: '/examineTender',
    component: (resolve) => require(['@/views/crm/mobile/examine/details/tender'], resolve),
    name: 'examineTender',
    hidden: true,
    meta: { title: '投标审批', icon: 'dashboard', noCache: true }
  },
  {
    path: '/examineSalesOrder',
    component: (resolve) => require(['@/views/crm/mobile/examine/details/salesOrder'], resolve),
    name: 'examineSalesOrder',
    hidden: true,
    meta: { title: '销售审批', icon: 'dashboard', noCache: true }
  },
  
  {
    path: '/mobileTenderDetail',
    component: (resolve) => require(['@/views/crm/mobile/tender/detail'], resolve),
    name: 'mobileTenderDetail',
    hidden: true,
    meta: { title: '投标详情', icon: 'dashboard', noCache: true }
  },
  // mobileTenderDetail
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        name: '首页',
        meta: { title: '首页', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  },

  {
    path: '/fast/report',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'reportReview/:reportCode',
        component: (resolve) => require(['@/views/fast/report/reportReview'], resolve),
        name: 'fastReportReportReview',
        //meta: { title: '报表预览' }
      },{
        path: 'reportDevReview/:reportCode',
        component: (resolve) => require(['@/views/fast/report/reportDevReview'], resolve),
        name: 'fastReportReportReview:reportCode',
        //meta: { title: '报表预览' }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/system/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/gen',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'edit/:tableId(\\d+)',
        component: (resolve) => require(['@/views/systempt/gen/editTable'], resolve),
        name: 'GenEdit',
        meta: { title: '修改生成配置' }
      }
    ]
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'Error Pages',
      icon: '404'
    },
    children: [
      {
        path: '401',
        component: () => import('@/views/error-page/401'),
        name: 'Page401',
        meta: { title: '401', noCache: true }
      },
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: { title: '404', noCache: true }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  if(to.path.indexOf("/fast/report/reportReview/")>=0){
    const menuReprotTitle = window.localStorage.getItem('menuReprotTitle');
    var allData = {};
    if (menuReprotTitle == null || menuReprotTitle.length === 0) {

    }else{
      allData = JSON.parse(menuReprotTitle);
    }

    to.meta.title = allData[to.params.reportCode];
    if(to.meta.title==null ){
      to.meta.title = '报表预览';
    }
  }

  next()
})

export default router
